import { LayoutPanelTop } from "lucide-react";

import BUTTON_TYPES from "@/lib/constants/buttonTypes";
import { SECTION_TYPES } from "@/lib/constants/sections";
import { constructImageUrl } from "@/lib/utils";

import type { WebsiteWithImages } from "@/types/prisma";
import type { ServiceSection } from "@/types/sections";
import type { Service } from "@prisma/client";

const serviceHeroSection: ServiceSection = {
  type: SECTION_TYPES.SERVICE_HERO,
  content: {
    header: "Brief description of page content",
    subheader: "Elaborate on this particular service page in a single paragraph.",
    bgImage: "", // optional
    showCustomButtons: false,
    buttons: [
      {
        type: BUTTON_TYPES.SITE_LINK,
        label: "Get in touch",
        link: "/contact-us",
      },
      {
        type: BUTTON_TYPES.EXTERNAL_LINK,
        label: "Find us here too",
        link: "https://google.com",
      },
    ],
  },
  meta: {
    displayName: "Service Page Intro",
    displayDescription: "Introduce your services to your customers.",
    displayIcon: LayoutPanelTop,
  },
  aiPrompt(service: Service, website: WebsiteWithImages) {
    const images = website.images.map((image) => constructImageUrl(image.providerId, image.source!));

    return `For the Service Hero section of the service with the name: 
    "${service.name}", blurb: "${service.blurb}", and industry: "${website.industry}", 
    create an SEO-optimized H1 tag that includes the service name. 
    This H1 should be very short and include an SEO optimized version of the service name. 
    E.g. "Professional ${service.name} Services" or "Expert ${service.name} Services".
    Also, create a subheader (H2) that supports the H1 by elaborating on the unique selling points and additional benefits of the service.
    ${
      images
        ? "Additionally, pick an image suitable for the `bgImage` field: " +
          images.join(" | ") +
          "\nYOU ARE TO ONLY USE IMAGE URLS FROM THE PROVIDED IMAGE URLS AND NOT MAKE UP OF ANY URL."
        : ""
    }
    `;
  },
};

export default serviceHeroSection;
